import React from "react";
import { Routes, Route } from "react-router-dom";
import AboutMe from "./AboutMe";
import CV from "./CV";
import Works from "./Works";
export default function Index() {
  return (
    <div className="col-12 col-lg-11 col-md-7 px-0 px-lg-3">
      <div className="col-12 mt2 ">
        <div className="leftside">
          <div className="col-12 mt-4">
            <div className="row">
              <div className="col-12 ">
                <div className=" col-12">
                  <div className="tab-content">
                    <Routes>
                      <Route path="/" element={<AboutMe />} />
                      <Route path="/AboutMe" element={<AboutMe />} />
                      <Route path="/CV" element={<CV />} />
                      <Route path="/Works" element={<Works />} />
                    </Routes>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
